import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { helpCenterSettingsServiceHubsAppEntryPoint as main } from '@atlassian/jira-spa-apps-help-center-settings-service-hubs/entrypoint.tsx';

export const helpCenterSettingsServiceHubsRoutePageEntryPoint = createPageEntryPoint({
	main,
	// TODO update to right menu id
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});
